import React from 'react'

export default function ToolbarStyle() {
  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #toolbar {
          background-color: var(--main-background-color);
          /*background-color: rgba(211, 205, 199, 1);*/
          grid-area: toolbar;
          height: 56px;
          display: flex;
          /*border-bottom: solid #CCC 2px;*/
        }

        #toolbar .pospro-action-btn {
          margin: 5px 0;
        }

        #loading-indicator-container {
          display: flex;
          flex: 7;
          margin: auto;
          justify-content: flex-start;
          font-size: 0.85rem;
        }

        #logo-container {
          display: flex;
          margin-right: 20px;
          margin-left: 5px;
          font-family: "Segoe UI", sans-serif;
        }
        #pos22-logo { margin: auto; }

        /*
        #brand {
          color: rgb(31, 191, 11);
          font-size: 1.6rem;
          font-weight: bold;
          align-self: flex-end;
          margin: auto;
          margin-bottom: 3px;
        }
        #version {
          align-self: flex-end;
          color: lightgrey;
          font-size: 1rem;
          margin-bottom: 5px;
        }

        #switch-pos-button {
          font-size: 0.7em;
          margin: 5px 0;
          margin-right: 5px;
          padding: 5px 10px;
          background-color: rgba(252, 243, 5, 0.9);
          border: none;
          color: var(--main-background-color);
          border-radius: 3px;
        }

        #switch-pos-button:hover {
          background-color: rgba(252, 243, 5, 0.9);
          cursor: pointer;
          transform: scale(1.05);
        }
        */

        #client-user-button-wrapper {
          background-color: blue;
          display: flex;
          flex-direction: column;
        }
        #client-user-button {
          font-size: 0.7em;
          margin: 5px ;
          margin-right: 5px;
          padding: 5px 10px;
          background-color: transparent;
          border: none;
          color: whitesmoke;
          /*color: rgba(22, 22, 22, 1);*/
          border-radius: 3px;
        }
        #client-user-button:hover {
          cursor: pointer;
          color: white;
        }

        .dropdown-window {
          z-index: 1;
          display: none;
          position: absolute;
          top: 50px;
          right: 10px;
          padding: 10px;
          background-color: grey;
          flex-direction: column;
          box-shadow: 2px 3px 8px 5px rgba(0, 0, 0, 0.12);
          /* smooth shadow */
          /*
          box-shadow:
            0 2.8px 2.2px rgba(0, 0, 0, 0.034),
            0 6.7px 5.3px rgba(0, 0, 0, 0.048),
            0 12.5px 10px rgba(0, 0, 0, 0.06),
            0 22.3px 17.9px rgba(0, 0, 0, 0.072),
            0 41.8px 33.4px rgba(0, 0, 0, 0.086),
            0 100px 80px rgba(0, 0, 0, 0.12);
          */
        }
        .dropdown-window button {
          background-color: transparent;
          border: solid 0.5px transparent;
          padding: 5px;
          text-align: left;
        }
        .dropdown-window button:hover {
          border: solid 0.5px lightgrey;
          cursor: pointer;
          color: whitesmoke;
        }

        .show { display: flex; }

        .timezone-wrapper {
          color: whitesmoke;
          /*color: rgba(22, 22, 22, 1);*/
          margin: auto;
          font-size: 0.8rem;
        }
        .timezone { color: rgba(10, 200, 10, 1); font-weight: bold; }

      `}
      </style>
    </React.Fragment>
  )
}
